import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SessionStorageService } from 'ngx-webstorage';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { HomeService } from 'src/app/modules/home/home.service';
import { IResponse } from 'src/app/shared/models/app';

@Component({
    selector: 'nphs-wo-application-alert',
    templateUrl: './application-alert.component.html',
    styleUrls: ['./application-alert.component.scss'],
    standalone: false
})
export class ApplicationAlertComponent implements OnInit {

  appMaintenanceObj:any={};
  releaseNoteFlag = false;
  isReleaseNoteAvailable = false;
  appMaintenanceReleaseNote: any=[];

  constructor(private storage:SessionStorageService,public dialog: MatDialogRef<ApplicationAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogdata,
    public dialogRef: MatDialog,
    private homeService:HomeService,
    private cache:CacheResolverService) { }

  ngOnInit(): void {
    this.appMaintenanceObj = this.dialogdata.appMaintenanceObj;
    this.isReleaseNoteAvailable = this.dialogdata.isReleaseNoteAvailable;
    this.appMaintenanceReleaseNote = this.dialogdata.appMaintenanceReleaseNote;
  }

  closeMaintenanceBanner(){
    this.appMaintenanceObj.activeFlag = false;
    // this.cache.set(CacheConstant.LocalStorage.NuctracAppMaintenance,this.appMaintenanceObj);
    this.dialog.close();
  }

  dismissMaintenanceBanner(){
    this.appMaintenanceObj.activeFlag = false;
    // this.cache.set(CacheConstant.LocalStorage.NuctracAppMaintenance,this.appMaintenanceObj);
    let userId = this.cache.get(CacheConstant.LocalStorage.UserDetails).userDetailNum;
    this.homeService.dismissMaintenanceAlert(this.appMaintenanceObj.appMaintenanceNum,userId).subscribe((response:IResponse)=>{
      
    });
    this.dialog.close();
  }

  showReleaseNotes() {
    this.releaseNoteFlag = !this.releaseNoteFlag;
  }

}
